export default __webpack_public_path__ + "static/media/profile_alt.c9dae346.png";